import { fetchData } from '@umu/umu-fetch';
import { API_TYPE, IMemberList } from '@umu/umu-types';
import { SugMemberListParams } from './type';

export interface IPageInfo {
    current_page: number;
    list_total_num: number;
    total_num: number;
    size: number;
    total_page_num: number;
}
export interface IMemberListParam {
    department_id: string | number;
    size: number;
    page: number;
}
export interface IMemberListInfo {
    page_info: IPageInfo;
    list: IMemberList[];
}
export const getNotInDepartmentMemberList = (data: IMemberListParam) => {
    return fetchData(
        {
            url: `/uapi/v1/department/users-not-in-department`,
            type: API_TYPE.GET,
        },
        data,
    ).then((res: IListResponse<IMemberListInfo>) => {
        return res.data;
    });
};

export const getSugMemberList = (data: SugMemberListParams) => {
    return fetchData(
        {
            url: `/uapi/v1/enterprise/user-list`,
            type: API_TYPE.GET,
        },
        data,
    ).then((res: IListResponse<IMemberListInfo>) => {
        return res.data;
    });
};

export const getMemberInfoByUmuIds = (data: { umu_ids: string }) => {
    return fetchData(
        {
            url: `/uapi/v1/enterprise/get-user-infos`,
            type: API_TYPE.GET,
        },
        data,
    ).then((res: IListResponse<IMemberListInfo>) => {
        return res.data;
    });
};
